<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()" aria-label="Go back">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">{{ 'SCOUTS.TITLE' | translate | uppercase }}</span>
    <span class="spacer"></span>
    <button mat-icon-button color="primary" type="button" (click)="openNewScout()" style="margin-right: 8px;">
      <mat-icon>person_add</mat-icon>
      <!-- {{ 'SCOUTS.NEW_SCOUT' | translate }} -->
    </button>
    <button mat-icon-button aria-label="Refresh scouts" (click)="loadScouts()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (!isLoading && loadError) {
    <div style="padding: 8px 0; color: gray;">{{ 'SCOUTS.ERROR' | translate }}</div>
  }

  <div class="filters-row">
    <mat-form-field appearance="outline" class="filter-field-search">
      <mat-label>{{ 'SCOUTS.SEARCH_LABEL' | translate }}</mat-label>
      <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" [placeholder]="'SCOUTS.SEARCH_PLACEHOLDER' | translate" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field-status">
      <mat-label>{{ 'SCOUTS.STATUS' | translate }}</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="applyFilters()">
        <mat-option value="all">{{ 'SCOUTS.STATUS_ALL' | translate }}</mat-option>
        <mat-option value="active">{{ 'SCOUTS.STATUS_ACTIVE' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-card appearance="outlined" style="margin-top: 12px;">
    <mat-nav-list>
      @for (scout of filteredScouts; track scout.UserId) {
        <div mat-list-item class="scout-row">
          <button mat-icon-button type="button" class="scout-icon-button" (click)="openScoutDetails(scout)" aria-label="Open scout details">
            <mat-icon>person</mat-icon>
          </button>

          <button type="button" class="scout-main" (click)="openScoutDetails(scout)">
            <span class="scout-title">{{ getScoutName(scout) }}</span>
            <span class="scout-subtitle">{{ scout.Email }}</span>
          </button>

          <div class="scout-toggle-wrap" (click)="$event.stopPropagation()">
            <span class="scout-toggle-state">{{ isActiveScout(scout) ? ('SCOUTS.STATE_ACTIVE' | translate) : ('SCOUTS.STATE_DISABLED' | translate) }}</span>
            <mat-slide-toggle
              [checked]="isActiveScout(scout)"
              [disabled]="isTogglePending(scout)"
              aria-label="Toggle scout active status"
              (change)="toggleScoutActive(scout, $event.checked)">
            </mat-slide-toggle>
          </div>
        </div>
        <mat-divider></mat-divider>
      }

      @if (!isLoading && filteredScouts.length === 0) {
        <div style="padding: 16px; color: gray;">{{ 'SCOUTS.EMPTY' | translate }}</div>
      }
    </mat-nav-list>
  </mat-card>
</div>
